import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCaja from 'views/machine/reports/flujocaja/filterFlujoCaja'; // Importing filter component for cash flow
import TableFlujoCaja from 'views/machine/reports/flujocaja/tableFlujoCaja'; // Importing table component for cash flow
import DetailsFlujoCaja from 'views/machine/reports/flujocaja/detailsFlujoCaja'; // Importing details component for cash flow
import RecordFlujoCaja from 'views/machine/reports/flujocaja/recordFlujoCaja'; // Importing record component for cash flow
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FlujoCajaView.
 * @extends JetView
 */
export default class FlujoCajaView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            type: 'wide',
            rows: [PlayersView, RecordFlujoCaja, DetailsFlujoCaja], // Rows for the right side of the layout
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for the dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Option for exporting to Excel
                        { id: '2', value: 'PDF' }, // Option for exporting to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the datatable instance
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Flujo de Caja'), // Filename for the exported file
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo de Caja'), // Filename for the exported file
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown value
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                FilterFlujoCaja, // Filter component for cash flow
                TableFlujoCaja, // Table component for cash flow
                toolbar, // Toolbar component
            ],
        };
        return {
            type: 'wide',
            responsive: true,
            css: 'out', // CSS class for the main layout
            cols: [
                left, // Left column containing filter, table, and toolbar
            ],
        };
    }
}

// FILE DOCUMENTED
